"use strict";
/**
 *  @module SDK
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentsSDK = void 0;
var tslib_1 = require("tslib");
var events_1 = require("events");
var RestAPI_js_1 = require("../api/RestAPI.js");
var PaymentsSDK = /** @class */ (function (_super) {
    tslib_1.__extends(PaymentsSDK, _super);
    function PaymentsSDK(options) {
        var _this = _super.call(this) || this;
        _this.api = new RestAPI_js_1.RestAPI(options);
        _this.on("newListener", function (event, listener) {
            if (event === "newListener" || event === "removeListener") {
                return;
            }
            _this.api.on(event, listener);
        });
        _this.on("removeListener", function (event, listener) { return _this.api.removeListener(event, listener); });
        return _this;
    }
    return PaymentsSDK;
}(events_1.EventEmitter));
exports.PaymentsSDK = PaymentsSDK;
//# sourceMappingURL=PaymentsSDK.js.map